export const isValidNumber = (val: unknown): val is number => {
  return typeof val === "number" && !isNaN(val);
};

export const safeStringCompare = (a: unknown, b: unknown): number => {
  const strA = typeof a === "string" ? a : String(a ?? "");
  const strB = typeof b === "string" ? b : String(b ?? "");
  return strA.localeCompare(strB, undefined, {
    sensitivity: "base",
    numeric: true,
  });
};
